import React from "react";

import "./appConfirm.css";

interface AppConfirmProps {
  header: string;
  message: string;
  yesBtnText: string;
  noBtnText: string;
  onClickYes: () => void;
  onClickNo: () => void;
  onClose: () => void;
  icon?: React.ReactNode;
  variant?: "default" | "danger";
}

function AppConfirm({
  message,
  yesBtnText,
  noBtnText,
  onClickNo,
  onClickYes,
  onClose,
  header,
  icon,
  variant = "default",
}: AppConfirmProps) {
  return (
    <div className={`confirm-content ${variant === "danger" ? "confirm-content--danger" : ""}`}>
      <button
        type="button"
        className="confirm-close-btn"
        onClick={() => {
          onClickNo();
          onClose();
        }}
        aria-label="Close"
      >
        <i className="fa fa-times" />
      </button>

      {icon && <div className="confirm-icon-wrap">{icon}</div>}

      <div className="confirm-body">
        <h5 className="confirm-header">{header}</h5>
        <p className="confirm-message">{message}</p>
      </div>

      <div className="confirm-actions">
        <button
          className="confirm-btn confirm-btn--cancel"
          onClick={() => {
            onClickNo();
            onClose();
          }}
        >
          {noBtnText}
        </button>
        <button
          className={`confirm-btn confirm-btn--confirm ${variant === "danger" ? "confirm-btn--danger" : ""}`}
          onClick={() => {
            onClickYes();
            onClose();
          }}
        >
          {yesBtnText}
        </button>
      </div>
    </div>
  );
}

export default AppConfirm;
